import EstoreService from "@/services/EstoreService.js";
import { getField, updateField } from "vuex-map-fields";
import _ from "lodash";
import Vue from "vue";
import router from "@/router";
import { isJSON } from "../../utilities";

export default {
  namespaced: true,
  state: {
    loading_voucher: false,
    loading: false,
    loadingOverlay: false,
    errors: null,
    products: [],
    specificProduct: null,
    categories: null,
    publicCategories: [],
    orders: [],
    orderDetails: null,
    modal: { status: false },
    cart: null,
    checkout: null,
    productInventoryListByBranch: [],
    voucher: null,
    billingAddress: null,
    paynamics: null,
    webDesign: {
      design: {
        button_text_color: "#fff",
        logo: null,
        main_color: "#ff8a00",
        merchant_uuid: "",
        published: "",
        title: "",
        updated_at: "",
        uuid: ""
      }
    },
    notWithinBranch: [],
    deliverPickUp: null,
    isFollowUpOrderSent: false,
    isCancellingOrder: false,
    cancelledOrderMsg: null,
    payMongoData: null,
    hideMap: false,
    isFullScreen: false,
    maxPage: 0,
    nextPage: 0,
    payMongoPaymentIntent: null,
    productsByCategory: [],
    deleteAccountStatus: false,
    updateDeliveryErrors: null,
    ordersLoading: false,
    availableCodes: null,
    storeDetails: null,
    proofOfLogisticsData: {},
    specialDiscountValidationStatus: null,
    specialDiscountToDelete: null,
    cartSpecialDiscount: null,
    pointDetails: null,
    selectedPaymentMethod: null,
    transactionLimitErrorDisplay: {}
  },
  mutations: {
    updateField,
    SET_STORE_DETAILS(state, details) {
      state.storeDetails = details;
    },
    SET_MODAL(state, value) {
      state.modal.status = value.status;
    },
    SET_LOADING_VOUCHER(state, value) {
      state.loading_voucher = value;
    },
    SET_LOADING(state, value) {
      state.loading = value;
    },
    SET_LOADING_OVERLAY(state, value) {
      state.loadingOverlay = value;
    },
    SET_ERRORS(state, errors) {
      state.errors = errors;
    },
    RESET_ERRORS(state) {
      state.errors = null;
    },
    SET_PRODUCTS(state, products) {
      if (state.products == null) {
        state.products = products;
      } else {
        const key = "uuid";
        state.products = [
          ...new Map(
            [...state.products, ...products].map(item => [item[key], item])
          ).values()
        ];
      }
    },
    SET_SPECIFIC_PRODUCT(state, specificProduct) {
      state.specificProduct = specificProduct;
    },
    SET_CATEGORIES(state, categories) {
      state.categories = categories;
    },
    SET_PUBLIC_CATEGORIES(state, publicCategories) {
      state.publicCategories = publicCategories;
    },
    SET_ORDERS(state, orders) {
      state.orders = orders;
    },
    SET_ORDER_DETAILS(state, orderDetails) {
      state.orderDetails = orderDetails;
    },
    SET_CART(state, cart) {
      state.cart = cart;
    },
    SET_CHECKOUT(state, checkout) {
      state.checkout = checkout;
    },
    SET_VOUCHER(state, voucher) {
      state.voucher = voucher;
    },
    SET_BILLING_ADDRESS(state, billingAddress) {
      state.billingAddress = billingAddress;
    },
    SET_PAYNAMICS(state, paynamics) {
      state.paynamics = paynamics;
    },
    SET_WEB_DESIGN(state, webDesign) {
      state.webDesign = webDesign;
    },
    SET_NOT_WITHIN_BRANCH(state, notWithinBranch) {
      state.notWithinBranch = notWithinBranch;
    },
    SET_DELIVER_PICKUP(state, deliverPickUp) {
      state.deliverPickUp = deliverPickUp;
    },
    SET_IS_FOLLOW_UP_ORDER_SENT(state, payload) {
      state.isFollowUpOrderSent = payload;
    },
    SET_CANCEL_ORDER(state, status) {
      state.isCancellingOrder = status;
    },
    SET_CANCELLED_ORDER_MSG(state, msg) {
      state.cancelledOrderMsg = msg;
    },
    SET_PAYMONGO_DATA(state, payload) {
      state.payMongoData = payload;
    },
    SET_HIDE_MAP(state, payload) {
      state.hideMap = payload;
    },
    SET_IS_FULL_SCREEN(state, payload) {
      state.isFullScreen = payload;
    },
    SET_MAX_PAGE(state, maxPage) {
      state.maxPage = maxPage;
    },
    SET_NEXT_PAGE(state, nextPage) {
      state.nextPage = nextPage;
    },
    SET_PAYMONGO_PAYMENT_INTENT(state, payload) {
      state.payMongoPaymentIntent = payload;
    },
    setProductsByCategory(state, payload) {
      state.productsByCategory = payload;
    },
    setDeleteAccountStatus(state, payload) {
      state.deleteAccountStatus = payload;
    },
    setUpdateDeliveryErrors(state, payload) {
      state.updateDeliveryErrors = payload;
    },
    setOrdersLoading(state, payload) {
      state.ordersLoading = payload;
    },
    resetProductsAndPagination(state) {
      state.products = [];
      state.maxPage = 0;
      state.nextPage = 0;
    },
    resetProducts(state) {
      state.products = [];
    },
    setAvailableCodes(state, payload) {
      state.availableCodes = payload;
    },
    setSpecialDiscountValidationStatus(state, value) {
      state.specialDiscountValidationStatus = value;
    },
    setCartSpecialDiscount(state, value) {
      state.cartSpecialDiscount = value;
    },
    setPointDetails(state, value) {
      state.pointDetails = value;
    }
  },
  getters: {
    getField,
    getDeliveryConfig(state) {
      return state.cart.list.map(obj => {
        return {
          brand: obj.brand_name,
          brand_uuid: obj.brand_uuid,
          branch: obj.branch_name,
          branch_uuid: obj.branch_uuid,
          deliveryType: obj.delivery_type,
          pickup_datetime: obj.pickup_datetime,
          fees: obj.fees
        };
      });
    },
    transactionId(state) {
      return state.checkout !== null ? state.checkout.order : null;
    },
    isCancellingOrder: state => state.isCancellingOrder,
    errors: state => state.errors,
    cancelledOrderMsg: state => state.cancelledOrderMsg,
    loading: state => state.loading,
    cancellationReasons: state => 
      state.storeDetails && state.storeDetails.cancellation_reasons ? 
        state.storeDetails.cancellation_reasons : 
        [],
    design: state => _.get(state.webDesign, "design", {}),
    payMongoPaymentData: state =>
      state.payMongoData ? state.payMongoData.payment_data : null,
    storeDetails: state => state.storeDetails,
    bankOptions: state => {
      const bankOptions = [];

      if (
        state.storeDetails && 
        state.storeDetails.bank_accounts &&
        state.storeDetails.bank_accounts.length
      ) {
        for (const bankAccount of state.storeDetails.bank_accounts) {
          bankOptions.push({
            text: bankAccount.bank,
            value: bankAccount.uuid,
          });
        }
      }

      return bankOptions; 
    }, 
    orders: state =>
      state.orders
        ? state.orders.map(order => {
            order.orders.map(item => {
              if (item.status === "payment_pending") item.status = "pending";

              if (item.delivery_type.toLowerCase().includes("pick")) {
                if (item.status === "dispatched") item.status = "pick_up";
                if (item.status === "delivered") item.status = "claimed";
              }
            });
            return order;
          })
        : [],
    orderDetails: state => {
      if (state.orderDetails) {
        state.orderDetails.orders.map(order => {
          if (order.status === "payment_pending") order.status = "pending";

          if (order.delivery_type.toLowerCase().includes("pick")) {
            if (order.status === "dispatched") order.status = "pick_up";
            if (order.status === "delivered") order.status = "claimed";
          }

          return order;
        });

        if (state.orderDetails.voucher_info && isJSON(state.orderDetails.voucher_info))
          state.orderDetails.voucher_info = JSON.parse(state.orderDetails.voucher_info);
      }

      return state.orderDetails;
    },
    cart: state => state.cart,
    cartUuid: state => state.cart && state.cart.cart_uuid ?
      state.cart.cart_uuid : 
      Vue.$cookies.get("cart_uuid"),
    isAllowMultipleBranch: state => !!_.get(state.storeDetails, "allow_purchase_multiple", false),
    specialDiscountSettings: state => _.get(state.storeDetails, "special_discount[0]", null),
    isSpecialDiscountEnabled: state => !!(_.get(state.storeDetails, "special_discount[0].is_enabled", false)
      && _.get(state.storeDetails, "special_discount[0].channels", []).includes('estore')),
    hasCartSpecialDiscountItem: state => 
      _.get(state.cart, "list[0].items", []).some(({ product_inventory }) => _.get(product_inventory, "product_details.enable_special_discount", false)),
    specialDiscountTotal: (getters) => {
      let amount = 0;
      _.get(getters["orderDetails"], "orders", []).forEach(({ special_discount_computed_amount }) => amount += Number(special_discount_computed_amount));
      return amount;
    },
    isRejectedSpecialDiscount: state => 
      _.get(state.specialDiscountValidationStatus, "special_discount_approved") === 0, 
    isOrderRejectedSpecialDiscount: state => 
      _.get(state.orderDetails, "orders[0].special_discount_approved") === 0, 
    isOrderApprovedSpecialDiscount: state => 
      _.get(state.orderDetails, "orders[0].special_discount_approved") === 1, 
    orderSpecialDiscountType: state => 
      _.get(state.orderDetails, "orders[0].special_discount_types"), 
    isSingleBranchCart: state => 
      _.get(state.cart, "list.length") === 1,
    isOrderCompleted: (state) => {
      if (!state.orderDetails) return false;

      return state.orderDetails.orders.every(
        (order) => ["delivered", "claimed"].includes(order.status)
      );
    },
    isPayWithPointsEnabled: state => !!Number(_.get(state.storeDetails, "pay_with_points_estore_enabled")),
    pointsUsed: state => Number(_.get(state.cart, "points_used", 0)),
    pointsValue: state => Number(_.get(state.cart, "points_value", 0)),
    computedTotal: state => _.get(state.cart, "computed_total", 0),
    cartTotal: state => {
     const cartTotal = _.get(state.cart, "computed_total", 0) - 
      Number( _.get(state.cartSpecialDiscount, "special_discount_computed_amount", 0));

     return cartTotal < 0 ? 0 : cartTotal;
    },
    specialDiscountComputedAmount: state => 
      Number( _.get(state.cartSpecialDiscount, "special_discount_computed_amount", 0)),
    cartList: state => _.get(state.cart, "list", []),
    isPointsEarningEnabled: state => _.get(state.storeDetails, "points_earning_enabled", false),
    isEstoreEnabled: state => !!_.get(state.storeDetails, "enable_estore", false),
    isLoyaltyEnabled: state => !!_.get(state.storeDetails, "enable_loyalty", false)
  },
  actions: {
    async getStoreDetails({ commit }, request) {
      commit("SET_LOADING", true);
      
      try {
        if (request.header.Authorization) {
          const  { details } = await EstoreService.getStoreDetails(request);
          
          commit("SET_STORE_DETAILS", details);
        } else {
          const  { details } = await EstoreService.getPublicStoreDetails(request);
          
          commit("SET_STORE_DETAILS", details);
        }
      } catch (errors) {
        commit("SET_ERRORS", errors);
      } finally {
        commit("SET_LOADING", false);
      }
    },
    async resetErrors({ commit }) {
      commit("RESET_ERRORS");
    },
    async getPublicProducts({ commit }, request) {
      commit("SET_LOADING", true);
      commit("SET_LOADING_OVERLAY", true);
      try {
        const response = await EstoreService.getPublicProducts(request);

        commit("SET_PRODUCTS", response.list);
        commit("SET_MAX_PAGE", response.max_page);
        commit("SET_NEXT_PAGE", response.next_page);
        commit("SET_LOADING", false);
        commit("SET_LOADING_OVERLAY", false);
      } catch (errors) {
        commit("SET_ERRORS", errors);
        commit("SET_LOADING", false);
        commit("SET_LOADING_OVERLAY", false);
      }
    },
    async getProducts({ commit }, request) {
      commit("SET_LOADING", true);
      commit("SET_LOADING_OVERLAY", true);
      try {
        const response = await EstoreService.getProducts(request);

        commit("SET_PRODUCTS", response.list);
        commit("SET_MAX_PAGE", response.max_page);
        commit("SET_NEXT_PAGE", response.next_page);
        commit("SET_LOADING", false);
        commit("SET_LOADING_OVERLAY", false);
      } catch (errors) {
        commit("SET_ERRORS", errors);
        commit("SET_LOADING", false);
        commit("SET_LOADING_OVERLAY", false);
      }
    },
    async getPublicProductsByNavigation({ commit }, request) {
      commit("SET_LOADING", true);
      commit("SET_LOADING_OVERLAY", true);
      try {
        const response = await EstoreService.getPublicProducts(request);

        commit("SET_PRODUCTS", response.list);
        commit("SET_LOADING", false);
        commit("SET_LOADING_OVERLAY", false);
      } catch (errors) {
        commit("SET_ERRORS", errors);
        commit("SET_LOADING", false);
        commit("SET_LOADING_OVERLAY", false);
      }
    },
    async getProductsByNavigation({ commit }, request) {
      commit("SET_LOADING", true);
      commit("SET_LOADING_OVERLAY", true);
      try {
        const response = await EstoreService.getProducts(request);

        commit("SET_PRODUCTS", response.list);
        commit("SET_LOADING", false);
        commit("SET_LOADING_OVERLAY", false);
      } catch (errors) {
        commit("SET_ERRORS", errors);
        commit("SET_LOADING", false);
        commit("SET_LOADING_OVERLAY", false);
      }
    },
    async getSpecificProduct({ commit }, request) {
      commit("SET_LOADING", true);
      commit("SET_LOADING_OVERLAY", true);
      try {
        let response;
        if (request.header.Authorization)
          response = await EstoreService.getSpecificProduct(request);
        else
          response = await EstoreService.getSpecificPublicProduct(request);

        commit("SET_SPECIFIC_PRODUCT", response);
        commit("SET_LOADING", false);
        commit("SET_LOADING_OVERLAY", false);
      } catch (errors) {
        commit("SET_ERRORS", errors);
        commit("SET_LOADING", false);
        commit("SET_LOADING_OVERLAY", false);
      }
    },
    async getSpecificPublicProduct({ commit }, request) {
      commit("SET_LOADING", true);
      commit("SET_LOADING_OVERLAY", true);
      try {
        let response = await EstoreService.getSpecificPublicProduct(request);
        commit("SET_SPECIFIC_PRODUCT", response);
        commit("SET_LOADING", false);
        commit("SET_LOADING_OVERLAY", false);
      } catch (errors) {
        commit("SET_ERRORS", errors);
        commit("SET_LOADING", false);
        commit("SET_LOADING_OVERLAY", false);
      }
    },
    async getCategories({ commit }, request) {
      commit("SET_LOADING", true);
      try {
        let response = await EstoreService.getCategories(request);
        commit("SET_CATEGORIES", response.list);
        commit("SET_LOADING", false);
      } catch (errors) {
        commit("SET_ERRORS", errors);
        commit("SET_LOADING", false);
      }
    },
    async getPublicCategories({ commit }, request) {
      commit("SET_LOADING", true);
      try {
        let response = await EstoreService.getPublicCategories(request);
        commit("SET_PUBLIC_CATEGORIES", response.list);
        commit("SET_LOADING", false);
      } catch (errors) {
        commit("SET_ERRORS", errors);
        commit("SET_LOADING", false);
      }
    },
    async getOrders({ commit }, request) {
      commit("setOrdersLoading", true);

      try {
        commit("SET_ORDERS", []);
        const response = await EstoreService.getOrders(request);
        commit("SET_ORDERS", response.list);
      } catch (errors) {
        commit("SET_ERRORS", errors);
      } finally {
        commit("setOrdersLoading", false);
      }
    },
    async getOrderDetails({ commit }, request) {
      commit("SET_LOADING", true);
      commit("SET_LOADING_OVERLAY", true);
      commit("SET_ORDER_DETAILS", null);

      try {
        let response;

        if (request.header.Authorization)
          response = await EstoreService.getOrderDetails(request);
        else {
          response = await EstoreService.getPublicOrderDetails(request);
          if (response.list.customer_uuid != "-") {
            router.push({ name: 'Home' });
          }
        }
        commit("SET_ORDER_DETAILS", response.list);
        commit("SET_LOADING", false);
        commit("SET_LOADING_OVERLAY", false);
      } catch (errors) {
        commit("SET_ERRORS", errors);
        commit("SET_LOADING", false);
        commit("SET_LOADING_OVERLAY", false);
      }
    },
    async addToCart({ commit, state }, request) {
      const isGuest = !_.has(request.header, "Authorization");
      commit("SET_LOADING", true);
      commit("SET_LOADING_OVERLAY", true);
      try {
        let response;

        if (isGuest) {
          response = await EstoreService.guestAddToCart(request);
          if (
            !Vue.$cookies.isKey("cart_uuid") ||
            Vue.$cookies.get("cart_uuid") !== response.cart_uuid
          ) Vue.$cookies.set("cart_uuid", response.cart_uuid, "2d");
        } else response = await EstoreService.addToCart(request);

        commit("SET_CART", { ...state.cart, ...response });
        commit("SET_LOADING_OVERLAY", false);
        commit("SET_LOADING", false);
      } catch (errors) {
        commit("SET_LOADING_OVERLAY", false);
        commit("SET_ERRORS", errors);
        commit("SET_LOADING", false);
      }
    },
    async editCart({ commit }, request) {
      commit("SET_LOADING", true);
      try {
        if (request.header.Authorization)
          await EstoreService.editCart(request);
        else
          await EstoreService.guestEditCart(request);

        commit("SET_LOADING", false);
      } catch (errors) {
        commit("SET_ERRORS", errors);
        commit("SET_LOADING", false);
      }
    },
    async removeItem({ commit, state }, request) {
      commit("SET_LOADING", true);
      try {
        let response;

        if (request.header.Authorization) response = await EstoreService.removeItem(request);
        else response = await EstoreService.guestRemoveItem(request);

        commit("SET_CART", { ...state.cart, ...response });
        commit("SET_LOADING", false);
      } catch (errors) {
        commit("SET_ERRORS", errors);
        commit("SET_LOADING", false);
      }
    },
    async viewCart({ commit }, request) {
      commit("SET_LOADING", true);
      commit("SET_LOADING_OVERLAY", true);
      commit("SET_ERRORS", null);

      try {
        if (request.header.Authorization) {
          commit("SET_CART",
            await EstoreService.viewCart(request)
          );
        } else {
          commit("SET_CART",
            await EstoreService.viewPublicCart(request)
          );
        }
      } catch (errors) {
        commit("SET_ERRORS", errors);
      } finally {
        commit("SET_LOADING_OVERLAY", false);
        commit("SET_LOADING", false);
      }
    },
    async uploadCustomerDepositSlip({ commit }, request) {
      commit("SET_LOADING", true);
      try {
        await EstoreService.uploadCustomerDepositSlip(request);
        commit("SET_LOADING", false);
      } catch (errors) {
        if (errors.errors.message == "P") {
          commit("SET_ERRORS", {
            errors: {
              file_upload: "Previous uploaded deposit slip not yet reviewed"
            }
          });
        } else if (
          errors.errors.message == "Sorry, You can only upload three times."
        ) {
          commit("SET_ERRORS", {
            errors: {
              file_upload: "Sorry, You can only upload three times."
            }
          });
        } else {
          commit("SET_ERRORS", errors);
        }
        commit("SET_LOADING", false);
      }
    },
    async checkout({ commit }, request) {
      commit("SET_ERRORS", null);
      commit("SET_LOADING", true);
      commit("SET_LOADING_OVERLAY", true);

      let response;

      try {
        if (request.payload.get("cart_uuid"))
          response = await EstoreService.checkoutPublic(request);
        else
          response = await EstoreService.checkout(request);
        
        commit("SET_CHECKOUT", response);

        if (Object.keys(response).includes("errors")) {
          commit("SET_ERRORS", response);
          commit("medpadala/SET_ERRORS", response.message, { root: true });
        }
      } catch (errors) {
        commit("SET_ERRORS", errors);
      } finally {
        commit("SET_LOADING", false);
        commit("SET_LOADING_OVERLAY", false);
      }
    },
    async verifyVoucher({ commit }, request) {
      commit("SET_LOADING_VOUCHER", true);
      try {
        let response = await EstoreService.verifyVoucher(request);
        commit("SET_VOUCHER", response);
        commit("SET_LOADING_VOUCHER", false);
      } catch (errors) {
        commit("SET_ERRORS", errors);
        commit("SET_LOADING_VOUCHER", false);
      }
    },
    async applyVoucher({ commit, state }, request) {
      commit("SET_LOADING_VOUCHER", true);
      try {
        let response = await EstoreService.applyVoucher(request);
        commit("SET_CART", { ...state.cart, ...response });
        commit("SET_LOADING_VOUCHER", false);
      } catch (errors) {
        commit("SET_ERRORS", errors);
        commit("SET_LOADING_VOUCHER", false);
      }
    },
    async removeVoucher({ commit, state }, request) {
      commit("SET_LOADING_VOUCHER", true);
      try {
        const response = await EstoreService.removeVoucher(request);
        commit("SET_CART", { ...state.cart, ...response });
      } catch (errors) {
        commit("SET_ERRORS", errors);
      } finally {
        commit("SET_LOADING_VOUCHER", false);
      }
    },
    async updateDelivery({ commit, state }, request) {
      commit("SET_LOADING", true);
      commit("setUpdateDeliveryErrors", null);

      try {
        let response;

        if (request.header.Authorization)
          response = await EstoreService.updateDelivery(request);
        else
          response = await EstoreService.updatePublicDelivery(request);
        
        commit("SET_CART", { ...state.cart, ...response });
      } catch (errors) {
        commit("setUpdateDeliveryErrors", errors.errors);
      } finally {
        commit("SET_LOADING", false);
      }
    },
    async addBilling({ commit }, request) {
      commit("SET_LOADING", true);
      try {
        let response = await EstoreService.addBilling(request);
        commit("SET_BILLING_ADDRESS", response);
        commit("SET_ERRORS", null);
      } catch (errors) {
        commit("SET_ERRORS", errors);
      } finally {
        commit("SET_LOADING", false);
      }
    },
    async paynamics({ commit }, request) {
      commit("SET_LOADING", true);
      try {
        let response = await EstoreService.paynamics(request);
        commit("SET_PAYNAMICS", response);
        commit("SET_ERRORS", null);
        commit("SET_LOADING", false);
        return response;
      } catch (errors) {
        commit("SET_ERRORS", errors);
        commit("SET_LOADING", false);
      }
    },
    async gcashPaynamics({ commit }, request) {
      commit("SET_LOADING", true);
      try {
        let response = await EstoreService.gcashPaynamics(request);
        commit("SET_PAYNAMICS", response);
        commit("SET_ERRORS", null);
        commit("SET_LOADING", false);
        return response;
      } catch (errors) {
        commit("SET_ERRORS", errors);
        commit("SET_LOADING", false);
      }
    },
    async getWebDesign({ commit }, request) {
      commit("SET_LOADING", true);
      try {
        let response = await EstoreService.getWebDesign(request);

        if (response.design !== null) commit("SET_WEB_DESIGN", response);
        commit("SET_LOADING", false);
      } catch (errors) {
        commit("SET_ERRORS", errors);
        commit("SET_LOADING", false);
      }
    },
    async checkPaymentStatus({ commit }, request) {
      try {
        let response = await EstoreService.checkPaymentStatus(request);
        commit("SET_ERRORS", null);
        return response;
      } catch (errors) {
        commit("SET_ERRORS", errors);
      }
    },
    async checkBranches({ commit }, request) {
      commit("SET_ERRORS", null);
      
      try {

        if (request.header.Authorization) {
          const  { list } = await EstoreService.checkBranches(request);
          
          commit("SET_NOT_WITHIN_BRANCH", list);
        } else {
          const  { list } = await EstoreService.checkPublicBranches(request);
          
          commit("SET_NOT_WITHIN_BRANCH", list);
        }
      } catch (errors) {
        commit("SET_ERRORS", errors);
      }
    },
    async getDeliveryOptions({ commit }, request) {
      try {
        let response = await EstoreService.getDeliveryOptions(request);

        commit("SET_DELIVER_PICKUP", response);
        commit("SET_ERRORS", null);
        return response;
      } catch (errors) {
        commit("SET_ERRORS", errors);
      }
    },
    async followUpOrder({ commit }, request) {
      try {
        const response = await EstoreService.followUpOrder(request);

        commit(
          "SET_IS_FOLLOW_UP_ORDER_SENT",
          response["follow_up_sent"] ? response["follow_up_sent"] : false
        );
        commit("SET_ERRORS", null);
      } catch (errors) {
        commit("SET_ERRORS", errors);
      }
    },
    async cancelOrder({ commit }, request) {
      commit("SET_CANCEL_ORDER", true);
      try {
        const response = await EstoreService.cancelOrder(request);
        commit("SET_CANCELLED_ORDER_MSG", {
          message: response.message,
          order_status: response.order_status
        });
        commit("SET_ERRORS", null);
        return response;
      } catch (errors) {
        commit("SET_ERRORS", errors);
      } finally {
        commit("SET_CANCEL_ORDER", false);
      }
    },
    // MEDPadala
    async medPadalaBalanceInquiry({ commit }, request) {
      commit("medpadala/SET_LOADING", true, { root: true });
      try {
        const response = await EstoreService.medPadalaBalanceInquiry(request);
        commit("medpadala/SET_ERRORS", null, { root: true });
        commit("medpadala/SET_MEDPADALA_DATA", response, { root: true });
      } catch (errors) {
        commit("medpadala/SET_ERRORS", errors.errors, { root: true });
      } finally {
        commit("medpadala/SET_LOADING", false, { root: true });
      }
    },
    async medPadalaSaveAmount({ commit }, request) {
      commit("medpadala/SET_LOADING", true, { root: true });
      try {
        const response = await EstoreService.medPadalaSaveAmount(request);
        commit("medpadala/SET_ERRORS", null, { root: true });
        return response;
      } catch (errors) {
        commit("medpadala/SET_ERRORS", errors.errors, { root: true });
      } finally {
        commit("medpadala/SET_LOADING", false, { root: true });
      }
    },
    async medPadalaRemove({ commit }, request) {
      commit("medpadala/SET_LOADING", true, { root: true });
      try {
        const response = await EstoreService.medPadalaRemove(request);
        commit("medpadala/SET_ERRORS", null, { root: true });
        return response;
      } catch (errors) {
        commit("medpadala/SET_ERRORS", errors.errors, { root: true });
      } finally {
        commit("medpadala/SET_LOADING", false, { root: true });
      }
    },
    async payViaPayMongo({ commit }, request) {
      commit("SET_LOADING", true);
      commit("SET_ERRORS", null);
      commit("SET_PAYMONGO_DATA", null);

      try {
        const response = await EstoreService.payViaPayMongo(request);

        commit("SET_PAYMONGO_DATA", response);
      } catch (errors) {
        commit("SET_ERRORS", errors);
      } finally {
        commit("SET_LOADING", false);
      }
    },
    async getPayMongoPaymentIntent({ commit }, request) {
      commit("SET_ERRORS", null);

      try {
        const response = await EstoreService.getPayMongoPaymentIntent(request);

        commit(
          "SET_PAYMONGO_PAYMENT_INTENT",
          response.data ? response.data : null
        );
      } catch (errors) {
        commit("SET_ERRORS", errors);
      }
    },
    async deletePayMongoPaymentMethod(_, request) {
      try {
        await EstoreService.deletePayMongoPaymentMethod(request);
      } catch (errors) {
        console.log(errors);
      }
    },
    async getProductsByCategory({ commit }, request) {
      commit("SET_LOADING", true);
      commit("setProductsByCategory", []);

      try {
        const response = await EstoreService.getProductsByCategory(request);

        commit(
          "setProductsByCategory",
          response.list && Array.isArray(response.list) ? response.list : []
        );
        commit("SET_MAX_PAGE", response.max_page);
        commit("SET_NEXT_PAGE", response.next_page);
      } catch (errors) {
        commit("SET_ERRORS", errors);
      } finally {
        commit("SET_LOADING", false);
      }
    },
    async getPublicProductsByCategory({ commit }, request) {
      commit("SET_LOADING", true);
      commit("setProductsByCategory", []);

      try {
        const response = await EstoreService.getPublicProductsByCategory(
          request
        );

        commit(
          "setProductsByCategory",
          response.list && Array.isArray(response.list) ? response.list : []
        );
        commit("SET_MAX_PAGE", response.max_page);
        commit("SET_NEXT_PAGE", response.next_page);
      } catch (errors) {
        commit("SET_ERRORS", errors);
      } finally {
        commit("SET_LOADING", false);
      }
    },
    async getDeleteAccountStatus({ commit }, request) {
      commit("SET_LOADING", true);

      try {
        const { data } = await EstoreService.getDeleteAccountStatus(request);

        commit(
          "setDeleteAccountStatus",
          data?.deactivate_status ? data.deactivate_status : false
        );
      } catch (errors) {
        commit("SET_ERRORS", errors);
      } finally {
        commit("SET_LOADING", false);
      }
    },
    async getAvailableCodes({ commit }, payload) {
      commit("SET_LOADING", true);

      try {
        const data = await EstoreService.getAvailableCodes(payload);

        commit("setAvailableCodes", data);
      } catch (errors) {
        commit("SET_ERRORS", errors);
      } finally {
        commit("SET_LOADING", false);
      }
    },
    async applySpecialDiscountToCart({ commit, state }, request) {
      commit("SET_LOADING", true);

      try {
        const { data } = await EstoreService.applySpecialDiscountToCart(request);
        
        commit("setCartSpecialDiscount", { ...state.cartSpecialDiscount, ...data });
      } catch (errors) {
        commit("SET_ERRORS", errors);
      } finally {
        commit("SET_LOADING", false);
      }
    },
    async applySpecialDiscountToOrder({ commit }, request) {
      commit("SET_LOADING", true);

      try {
        await EstoreService.applySpecialDiscountToOrder(request);
      } catch (errors) {
        commit("SET_ERRORS", errors);
      } finally {
        commit("SET_LOADING", false);
      }
    },
    async validateSpecialDiscount({ commit, state }, request) {
      try {
        const { data } = await EstoreService.validateSpecialDiscount(request);
        const { invoice_url } = data;
        
        commit("setSpecialDiscountValidationStatus", data);
        commit("SET_CHECKOUT", { ...state.checkout, invoice_url });
      } catch (errors) {
        commit("SET_ERRORS", errors);
      }
    },
    async updateOrderSpecialDiscount({ commit }, request) {
      commit("SET_LOADING", true);

      try {
         await EstoreService.updateOrderSpecialDiscount(request);
      } catch (errors) {
        commit("SET_ERRORS", errors);
      } finally {
        commit("SET_LOADING", false);
      }
    },
    async deleteSpecialDiscount({ commit }, request) {
      commit("SET_LOADING", true);
      try {
        return await EstoreService.deleteSpecialDiscount(request);
      } catch ({ errors, status }) {
        if (errors.message) {
          commit("SET_ERRORS", { message: errors.message });
        } else commit("SET_ERRORS", errors);
      } finally {
        commit("SET_LOADING", false);
      }
    },
    async getPointDetails({ commit }, request) {
      commit("SET_LOADING", true);

      try {
        const { data } = await EstoreService.getPointDetails(request);
        
        commit("setPointDetails", data);
      } catch (errors) {
        commit("SET_ERRORS", errors);
      } finally {
        commit("SET_LOADING", false);
      }
    },
    async redeemPoints({ commit, state }, request) {
      commit("SET_LOADING", true);

      try {
        const response = await EstoreService.redeemPoints(request);
        
        commit("SET_CART", { ...state.cart, ...response });
      } catch (errors) {
        commit("SET_ERRORS", errors);
      } finally {
        commit("SET_LOADING", false);
      }
    }
  }
};
